import React, { useState, useRef } from "react";
import * as RB from "react-bootstrap";
import "../pages/InvestigationPage.css";

export const LabelList = (props) => {
    /**@type {Array} */
    const labelList = props.labelList;
    const selectFunc = props.onSelect;
    const [selected, setSelected] = useState(null);
    if (labelList.length === 0) {
        return <></>;
    }
    const clickHandle = (idx) => {
        setSelected(idx);
        selectFunc(idx);
    };
    const getBageColor = (idx) => {
        if (!("identified" in labelList[idx])) {
            return "primary";
        }
        return labelList[idx].identified ? "success" : "danger";
    };
    return (
        <RB.ListGroup id={props.id}>
            {labelList.map((item, idx) => {
                return (
                    <RB.ListGroup.Item
                        action
                        onClick={() => clickHandle(idx)}
                        key={idx}
                        variant={idx === selected ? "secondary" : ""}
                        className="d-flex justify-content-between align-items-start"
                    >
                        <div className="ms-2 me-auto">
                            {item.label.toUpperCase()}
                        </div>
                        <RB.Badge variant={getBageColor(idx)}>
                            {item.score.toFixed(2)}
                        </RB.Badge>
                    </RB.ListGroup.Item>
                );
            })}
        </RB.ListGroup>
    );
};
